import axios from "axios";
import ApiReports from ".";
import { generateMessageReturn } from "../../../../utils/messageFuncs";

class ApiReportFinancial extends ApiReports {
  basePathReport = "financial";

  payments = async (query: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${this.basePathReport}/pagamentos/${query}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Relatório Financeiro (Pagamentos)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  movimentacao = async (query: string) => {
    this.config.url = `${this.baseUrl}/${this.basePath}/${this.basePathReport}/movimentacao/${query}`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Relatório Movimentação Financeira (Empresas)",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };
}

export default ApiReportFinancial;
